import React from "react";
import cn from "classnames";
import styles from "./ConversationList.module.sass";
import NotificationBadge from "../NotificationBadge";

const ConversationItem = ({ 
    conversation, 
    isActive, 
    onClick,
    onContextMenu 
}) => {
    const { 
        name, 
        avatar, 
        avatars, // for group chats
        lastMessage, 
        timestamp, 
        unreadCount,
        isOnline,
        isGroup,
        memberCount,
        isTyping,
        handle,
        first_name
    } = conversation;
    
    const formatTimestamp = (timestamp) => {
        const now = new Date();
        const messageDate = new Date(timestamp);
        const diffMs = now - messageDate;
        const diffMins = Math.floor(diffMs / 60000);
        const diffHours = Math.floor(diffMs / 3600000);
        const diffDays = Math.floor(diffMs / 86400000);
        
        if (diffMins < 1) return "Now";
        if (diffMins < 60) return `${diffMins}m ago`;
        if (diffHours < 24) return `${diffHours}h ago`;
        if (diffDays === 1) return "Yesterday";
        if (diffDays < 7) return `${diffDays}d ago`;
        
        return messageDate.toLocaleDateString('en-US', { 
            month: 'short', 
            day: 'numeric' 
        });
    };
    
    const truncateMessage = (message, maxLength = 50) => {
        if (!message) return "";
        if (message.length <= maxLength) return message;
        return message.substring(0, maxLength) + "...";
    };
    
    const handleContextMenu = (e) => {
        e.preventDefault();
        if (onContextMenu) {
            onContextMenu(e, conversation);
        }
    };
    
    return (
        <div
            className={cn(styles.conversationItem, {
                [styles.active]: isActive,
                [styles.unread]: unreadCount > 0
            })}
            onClick={() => onClick(conversation)}
            onContextMenu={handleContextMenu}
        >
            <div className={styles.avatarContainer}>
                {isGroup && avatars ? (
                    <div className={styles.groupAvatars}>
                        {avatars.slice(0, 2).map((avatarUrl, index) => (
                            <img 
                                key={index}
                                src={avatarUrl || "/images/content/avatar-1.jpg"} 
                                alt="Avatar" 
                                className={styles.groupAvatar}
                                style={{ 
                                    zIndex: 2 - index,
                                    left: index * 12 + 'px'
                                }}
                            />
                        ))}
                    </div>
                ) : (
                    <img 
                        src={avatar || "/images/content/avatar-1.jpg"} 
                        alt={name} 
                        className={styles.avatar}
                    />
                )}
                {!isGroup && isOnline && (
                    <span className={styles.onlineIndicator} />
                )}
                {unreadCount > 0 && (
                    <NotificationBadge count={unreadCount} />
                )}
            </div>
            
            <div className={styles.content}>
                <div className={styles.header}>
                    <div className={styles.nameContainer}>
                        {!isGroup && (first_name || handle) ? (
                            <div>
                                <h4 className={styles.name}>
                                    {first_name ? (
                                        <span style={{ color: '#0f084b' }}>{first_name}</span>
                                    ) : handle ? (
                                        <span style={{ color: '#0f084b' }}>@{handle.replace(/^@/, '')}</span>
                                    ) : (
                                        name
                                    )}
                                </h4>
                                {handle && first_name && (
                                    <div style={{ opacity: 0.7, fontWeight: '400', fontSize: '14px', color: '#666', marginTop: '2px' }}>
                                        @{handle.replace(/^@/, '')}
                                    </div>
                                )}
                            </div>
                        ) : (
                            <h4 className={styles.name}>{name}</h4>
                        )}
                        {isGroup && memberCount && (
                            <span className={styles.memberCount}>
                                {memberCount} members
                            </span>
                        )}
                    </div>
                    <span className={styles.timestamp}>
                        {formatTimestamp(timestamp)}
                    </span>
                </div>
                <div className={styles.messagePreview}>
                    {isTyping ? (
                        <span className={styles.typing}>
                            <span className={styles.typingDot}></span>
                            <span className={styles.typingDot}></span>
                            <span className={styles.typingDot}></span>
                            typing...
                        </span>
                    ) : (
                        truncateMessage(lastMessage)
                    )}
                </div>
            </div>
        </div>
    );
};

export default ConversationItem;
